<template>
  <div id="app">
      <router-view />
    <media-footer class="media-768-footer"></media-footer>
  </div>
</template>

<script>
import mediaFooter from "./components/media/mediaFooter";

export default {
  name: "App",
  components: {
    mediaFooter,
  },
};
</script>

<style scoped>
  #app {
    position: relative;
  }
/*当屏幕尺寸大于768px时，应用下面的CSS样式隐藏*/
.header-hidden {
  display: none;
}
.media-768-header {
  display: none;
}

.media-768-footer {
  display: none;
  position: sticky;
  top: 400px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue